/* eslint-disable import/prefer-default-export */
import SDK from 'utils/sdk';
import { put, call, all, takeLatest } from 'redux-saga/effects';
import { listKeyMetricsUrls, listLookerUrls } from './actions';

export function* listUrlSaga() {
  try {
    yield put(listLookerUrls.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'getLocationsWithUrls']);
    yield put(listLookerUrls.success(data));
  } catch (error) {
    yield put(listLookerUrls.failure(error));
  } finally {
    yield put(listLookerUrls.fulfill());
  }
}

export function* listKeyMetricsUrlsSaga() {
  try {
    yield put(listKeyMetricsUrls.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'getKeyMetricsUrl']);
    yield put(listKeyMetricsUrls.success(data));
  } catch (error) {
    yield put(listKeyMetricsUrls.failure(error));
  } finally {
    yield put(listKeyMetricsUrls.fulfill());
  }
}

export function* lookerUrlWatcher() {
  yield all([takeLatest(listLookerUrls.trigger, listUrlSaga)]);
}

export function* keyMetricsUrlWatcher() {
  yield all([takeLatest(listKeyMetricsUrls.trigger, listKeyMetricsUrlsSaga)]);
}
